import { ComponentFactoryResolver, Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';
import { NEVER, of } from 'rxjs';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { NbComponentStatus, NbGlobalLogicalPosition, NbToastrService } from '@nebular/theme';
import { UserService } from '../@core/mock/users.service';
import * as $ from 'jquery';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Md5 } from 'ts-md5/dist/md5';
import jwt_decode from "jwt-decode";

@Injectable({ providedIn: 'root' })
export class ApiService {
  developingMode = false;
  api = 'https://app.dorisbank.com/';
  userInfo;
  routePath: any = [];


  // Services
  constructor(private http: HttpClient,
    public translate: TranslateService,
    public oidcSecurityService: OidcSecurityService,
    private router: Router,
    public userService: UserService,
    public deviceDetectorService: DeviceDetectorService,
    public toastrService: NbToastrService) {
    if (this.developingMode) {
      this.api = '';
    }
  }


  currentDirection = 'rtl';
  positions = NbGlobalLogicalPosition;
  onSetLanguage(language, langId) {
    localStorage.setItem('lang', langId);
  }

  showToast(content, status: NbComponentStatus) {
    this.toastrService.show(null, content, { status });
  }

  showMessage(message, id) {
    if (id === 1) {
      this.translate.get(message).subscribe((res) => {
        this.showToast(res, 'success');
      });
    } else if (id === 0) {
      this.translate.get(message).subscribe((response) => {
        this.showToast(response, 'danger');
      });
    } else {
      this.translate.get('Message.ServerError').subscribe((response) => {
        this.showToast(response, 'danger');
      });
    }

  }

  getMyIP(){
    return this.http.get('https://mac.medis.land/api/ip/getmyip').pipe(
      catchError(error => {
        if (error.status === 401) {
          // window.location.href = ' ';
          this.router.navigate(['']);
          return NEVER;      // <-- never emit after the redirect
        }
        // this.showMessage(' ', null);
        return of([]);
      })
    );
  }

  apiCall(method, route, body) {
    //  console.log(this.oidcSecurityService.getToken())
    // console.log(this.routePath);
    //  console.log(this.userInfo);
    const deviceDetector = this.deviceDetectorService.browser + this.deviceDetectorService.browser_version +
      this.deviceDetectorService.deviceType + this.deviceDetectorService.os + this.deviceDetectorService.os_version + this.userInfo.userID;
    // console.log(deviceDetector,'---------------')
    const md5deviceDetector = Md5.hashStr(deviceDetector);
    // console.log(md5deviceDetector, '111111111111111111111111111111111111111');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: localStorage.getItem('lang'),
      deviceHash: md5deviceDetector,
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });

    if (method === 'post') {
      return this.http.post(this.api + route, body, { headers }).pipe(
        catchError(error => {
          // window.location.href = ' ';
          this.router.navigate(['']);
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    } else if (method === 'get') {
      return this.http.get(this.api + route, { headers }).pipe(
        catchError(error => {
          if (error.status === 401) {
            // window.location.href = ' ';
            this.router.navigate(['']);
            return NEVER;      // <-- never emit after the redirect
          }
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    } else if (method === 'delete') {
      return this.http.delete(this.api + route, { headers }).pipe(
        catchError(error => {
          if (error.status === 401) {
            this.router.navigate(['']);
            // window.location.href = ' ';
            return NEVER;      // <-- never emit after the redirect
          }
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    } else if (method === 'put') {
      return this.http.put(this.api + route, body, { headers }).pipe(
        catchError(error => {
          if (error.status === 401) {
            this.router.navigate(['']);
            // window.location.href = ' ';
            return NEVER;      // <-- never emit after the redirect
          }
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    }
  }

  getMenus() {
    // var decoded = jwt_decode(this.oidcSecurityService.getToken());
    //  console.log('++++++++++++++++++++++', this.oidcSecurityService.getToken())
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: localStorage.getItem('lang'),
      deviceHash: '11111111111111111111111111111111',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + 'api/user/getMenus/', { headers }).pipe(
      catchError(error => {
        if (error.status == 403) {
          this.router.navigate(['forbidden']);
          this.showToast(this.translate.instant('YouDontHavePermissionToAccessThisSite'), 'danger');
        }
        return of([]);
      })
    );;
  }
  async GetProfile(id) {
    const profile = await this.apiCall('get', 'api/User/GetProfile/' + (id==0 ? '' : id), {}).toPromise();
    return profile['res'];
  }

  async GetCountries() {
    const countries = await this.apiCall('get', 'api/location/GetCountries/', {}).toPromise();
    return countries['res'];
  }

  async GetProvinces(countryid) {
    const provinces = await this.apiCall('get', 'api/location/GetProvinces/' + countryid, {}).toPromise();
    return provinces['res'];
  }

  async GetCities(id) { // load cities
    const cities = await this.apiCall('get', 'api/location/GetCities/' + id, {}).toPromise();
    return cities['res'];
  }
  async GetLanguages() {
    const languages = await this.apiCall('get', 'api/language/GetLanguages/', {}).toPromise();
    return languages['res'];
  }
  async GetImage(image) {
    if (image.includes('https://')) {
      return image;
    } else {
      const response = await this.apiCall('get', 'api/Media/GetImage/' + image, {}).toPromise();
      return response;
    }
  }
  // async GetVideo(md5) {
  //     const response = await this.apiCall('get', 'api/Media/GetVideo/' + md5, {}).toPromise();
  //     return response;
  // }
}
